/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlannedExperienceDay } from '../../models/planned-experience-day';
import { RegisterForExperienceDay } from '../../models/register-for-experience-day';

export interface RegisterForExperienceDay$Params {
  id: string;
      body?: RegisterForExperienceDay
}

export function registerForExperienceDay(http: HttpClient, rootUrl: string, params: RegisterForExperienceDay$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedExperienceDay>> {
  const rb = new RequestBuilder(rootUrl, registerForExperienceDay.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedExperienceDay>;
    })
  );
}

registerForExperienceDay.PATH = '/experienceday/{id}';
